export default "__VITE_ASSET__DKMb30MZ__"